import { useEffect, useState } from "react";
import { createPayment, getTariffs } from "../components/api";
import { Button } from "@mui/material";
import { $userData } from "../store/userData";
import { setNotificationMessage, setShowNotification } from "../store";
import { useUnit } from "effector-react";
import "../styles/payment.scss";

export const Payment = () => {
    const [tariffs, setTariffs] = useState([]);
    const userData = useUnit($userData);
    
    const canPay = userData.status === 4 || userData.status === 6 || userData.status === 2 || userData.status === 3 || userData.status === 7;

    useEffect(() => {
            getTariffs().then(data => {setTariffs(data)});
    }, []);

    const clickPay = (id) => {
        createPayment({ tariffId: id, userId: userData.id })
            .then(data => {
                window.open(data, '_blank');
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.message;
                setNotificationMessage(errorMessageData
                    ? errorMessageData
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }

    return (
        <div className="payment">
            <h2 className="payment__header">Оплата подписки для участия в аукционах</h2>
             {tariffs.map((tariff) => (
                <div className="payment__pay"  key={tariff.id}>
                    <span className="payment__name">на {tariff.name}</span>
                    <Button variant="contained" className="payment_button" disabled = {!canPay} onClick={() => clickPay(tariff.id)}>
                        {tariff.price} рублей
                    </Button>
                </div>
             ))}
        </div>

    );
};
